import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_search = _resolveComponent("van-search")!

  return (_openBlock(), _createBlock(_component_van_search, {
    modelValue: $setup.search,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => (($setup.search) = $event)),
      $setup.onUpdate
    ],
    shape: "round",
    "show-action": "",
    "left-icon": "",
    placeholder: "I'm looking for...",
    onSearch: $setup.onSearch
  }, {
    action: _withCtx(() => [
      _createVNode(_component_van_icon, {
        name: "search",
        size: "24",
        onClick: $setup.onSearch
      }, null, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["modelValue", "onUpdate:modelValue", "onSearch"]))
}